// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"4":"07dd57f4","11":"b244e812","14":"4f462f44","36":"8c2e3bff","74":"0f07c963","270":"219f681b","664":"ca9bba20","807":"1910ce33","890":"e1cabed6"}[chunkId] + ".js";
};